import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useOnboarding } from "../../../context/AdminSellerRegistrationOB";
import JWTContext from "../../../context/JWTContext";
import { SubmitHandler, useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import { useUploadSingleFile } from "../../../hooks/useUploadFile";
import { uploadSingleFile } from "../../../services/uploadService";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import Select from "react-select";
import { getData } from "country-list";

export const GenderEnum = Object.freeze({
  Male: 0,
  Female: 1,
});

export const IDTypeEnum = Object.freeze({
  NationalID: 0,
  Passport: 1,
  DriversLicense: 2,
});

const schema = yup
  .object({
    name: yup.string().required(),
    birthdate: yup.string().required(),
    gender: yup.number().oneOf(Object.values(GenderEnum)).required(),
    nationality: yup.string().required("select Nationality first"),
    idType: yup.number().oneOf(Object.values(IDTypeEnum)).required(),
    idNumber: yup.string().required(),
    idImage: yup.string().required(),
  })
  .required();

const SellerDocumentVerificationPersonal = () => {
  const navigate = useNavigate();

  const containerStyle = {
    width: "100%",
    height: "400px",
  };

  const [mapCenter, setMapCenter] = useState({
    lat: -6.9175,
    lng: 107.6191,
  });

  const { saveStep, data } = useOnboarding();
  const { register: registerAccount } = useContext(JWTContext);

  const [uploading, setUploading] = useState(false);
  const [attachments, setAttachments] = useState(""); // URLs only
  const [SellerIDattachment, setSellerIDattachment] = useState(""); // URLs only
  const fileInputRefSellerID = useRef(null);
  const countries = getData().map((c) => ({
    value: c.code,
    label: c.name,
  }));

  const {
    control,
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: data.name ?? "",
      birthdate: data.birthdate ?? "",
      gender: data.gender ?? GenderEnum.Male,
      nationality: data.nationality ?? "",
      idType: data.idType ?? IDTypeEnum.NationalID,
      idNumber: data.idNumber ?? "",
      idImage: data.idImage ?? "",
    },
  });

  const watchIdType = watch("idType");

  const inputClass = (field) =>
    `form-control p-10 ${errors[field] ? "is-invalid" : ""}`;

  const onSubmit = (data) => {
    // if (data.agreement) {
    console.log("FORM DATA SUBMIT:", data);
    saveStep({
      name: data.name,
      birthdate: data.birthdate,
      gender: data.gender,
      nationality: data.nationality,
      idType: data.idType,
      idNumber: data.idNumber,
      idImage: data.idImage,
    });
    navigate("/admin/shop-information-personal");
  };

  const onError = (errors) => {
    console.log("FORM ERRORS:", errors);
  };

  const readUserData = () => {
    if (localStorage.getItem("user") == null) {
      navigate("/login");
    }
  };

  const handleUploadSellerID = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);

    try {
      const formData = new FormData();
      formData.append("pictureFile", file);

      const result = await uploadSingleFile(formData);
      console.log(result.result.result);
      // result = [{ filePath: "..." }]
      // setAttachments(prev => [...prev, result.result.result]);
      setSellerIDattachment((prev) => result.result.result);

      // OPTIONAL: store in react-hook-form
      setValue("idImage", result.result.result, {
        shouldValidate: true,
        shouldDirty: true,
      });

      // console.log("type : " +typeof SellerIDattachment +" is empty? :" + (SellerIDattachment !== "") + " value : " + SellerIDattachment)
      console.log(SellerIDattachment[0]);
    } catch (err) {
      console.error(err);
      Swal.fire("Upload failed", err?.message || "Unknown error", "error");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  const onChange = (e) => {
    console.log(e);
    // setValue("country", result.result.result, {
    //         shouldValidate: true,
    //         shouldDirty: true
    //     });
  };

  useEffect(() => {
    readUserData();
    console.log(attachments);
  }, []);

  useEffect(() => {
    if (data.idImage) {
      setSellerIDattachment(data.idImage);
    }
  }, [data]);

  return (
    <div className="document-verification text_quicksand">
      <div className="container">
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <div className="text-18 fw-bold text-black mb-30">
            <span>Business Information</span>
          </div>

          <div className="form-group mb-40">
            <label className="form-label fw-bold mb-10">
              Full Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={inputClass("name")}
              {...register("name")}
              placeholder="Enter your name"
            />
          </div>
          <div className="row row-cols-1 row-cols-md-2">
            <div className="form-group mb-40">
              <label className="form-label fw-bold mb-10">
                Date of Birth <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className={inputClass("birthdate")}
                {...register("birthdate")}
                placeholder="Enter year established"
              />
            </div>
            <div className="form-group mb-40">
              <label className="form-label fw-bold mb-10">
                Gender <span className="text-danger">*</span>
              </label>
              <select
                className={inputClass("gender")}
                {...register("gender")}
                onChange={(e) => {
                    setValue('gender', parseInt(e.target.value))
                }}
              >
                <option value={GenderEnum.Male}>Male</option>
                <option value={GenderEnum.Female}>Female</option>
              </select>
            </div>
          </div>

          <div className="form-group mb-40">
            <label className="form-label fw-bold mb-10">
              Nationality <span className="text-danger">*</span>
            </label>
            {/* <Select
                            options={countries}
                            onChange={val => onChange(val)}
                             {...register("nationality")}
                            placeholder="Select Nationality"
                            // className={inputClass("country")}
                            styles={{ height: "49px" }}
                        /> */}
            <Controller
              name="nationality"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  options={countries}
                  placeholder="Select Nationality"
                  // onChange={(selected) => field.onChange(selected)}
                  value={countries.find((c) => c.value === field.value) || null}
                  onChange={(option) => {
                    field.onChange(option?.value); // ✅ STORE STRING ONLY
                  }}
                />
              )}
            />
          </div>

          <div className="text-18 fw-bold text-black mb-30">
            <span>Identity Verification</span>
          </div>

          <div className="form-group mb-40">
            <label className="form-label fw-bold mb-20">
              ID Type<span className="text-danger">*</span>{" "}
            </label>
            <div
              className="row row-cols-1 row-cols-sm-3 justify-content-between "
              style={{ maxWidth: "475px" }}
            >
              <label className="d-flex align-items-center gap-10 mb-32">
                <span className="position-relative">
                  <Form.Check
                    type="radio"
                    id="nationalidslct"
                    {...register("idType")}
                    onChange={(e) => setValue('idType', IDTypeEnum.NationalID)}
                    value={IDTypeEnum.NationalID}
                    checked={watchIdType == IDTypeEnum.NationalID}
                    className="ms-3 custom-circular-checkbox-red"
                    // Ensure the label text is clear for accessibility
                    aria-label={`Select item `}
                  />
                </span>
                <span
                  className="text-14 text-black"
                  style={{ color: "##40494C" }}
                >
                  National ID
                </span>
              </label>

              <label className="d-flex align-items-center gap-10 mb-32">
                <span className="position-relative ">
                  <Form.Check
                    type="radio"
                    id="passportslct"
                    {...register("idType")}
                    onChange={(e) => setValue('idType', IDTypeEnum.Passport)}
                    value={IDTypeEnum.Passport}
                    checked={watchIdType == IDTypeEnum.Passport}
                    className="ms-3 custom-circular-checkbox-red"
                    // Ensure the label text is clear for accessibility
                    aria-label={`Select item `}
                  />
                </span>
                <span
                  className="text-14  text-black"
                  style={{ color: "##40494C" }}
                >
                  Passport
                </span>
              </label>
              <label className="d-flex align-items-center gap-10 mb-32">
                <span className="position-relative ">
                  <Form.Check
                    type="radio"
                    id="driveridslct"
                    {...register("idType")}
                    onChange={(e) => setValue('idType', IDTypeEnum.DriversLicense)}
                    value={IDTypeEnum.DriversLicense}
                    checked={watchIdType == IDTypeEnum.DriversLicense}
                    className="ms-3 custom-circular-checkbox-red"
                    // Ensure the label text is clear for accessibility
                    aria-label={`Select item `}
                  />
                </span>
                <span
                  className="text-14  text-black"
                  style={{ color: "##40494C" }}
                >
                  Driver's Select
                </span>
              </label>
            </div>
          </div>

          <div className="form-group mb-40">
            <label className="form-label fw-bold mb-10">
              ID Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={inputClass("idNumber")}
              {...register("idNumber")}
              placeholder="Enter your ID number"
            />
          </div>

          <div className="mb-30 col-12">
            <label className="form-label fw-bold">
              ID Image <span className="text-danger">*</span>
            </label>

            <div className="d-flex gap-3 overflow-x-auto pb-4">
              {/* Upload button */}
              <div
                className="pictureattachmentthumbnail add_composite d-flex align-items-center justify-content-center border rounded"
                onClick={() => fileInputRefSellerID.current.click()}
              >
                {uploading ? (
                  <img
                    src="/assets/images/icons/gif/konzy.gif"
                    className="w-100 h-100"
                  />
                ) : (
                  <div className="text-center">
                    {SellerIDattachment[0] !== "" ? (
                      <div>
                        <img src="/assets/images/icon/uploadimage.png" />
                        <div className="text-9">Re Upload File</div>
                      </div>
                    ) : (
                      <div>
                        <img src="/assets/images/icon/uploadimage.png" />
                        <div className="text-9">Upload File</div>
                      </div>
                    )}
                  </div>
                )}

                <input
                  type="file"
                  ref={fileInputRefSellerID}
                  className="d-none"
                  accept="image/png,image/jpeg,image/jpg"
                  onChange={handleUploadSellerID}
                />
              </div>

              {SellerIDattachment != "" && (
                <div className="" style={{ width: "107px", height: "107px" }}>
                  <Link to={SellerIDattachment} className="h-100">
                    <img
                      src={SellerIDattachment}
                      className="w-100 h-100 rounded"
                    />
                  </Link>
                </div>
              )}
            </div>
            {errors.sellerID && (
              <small className="text-danger">{errors.sellerID.message}</small>
            )}
          </div>

          <div className="d-flex justify-content-end">
            {/* <button className="btn btn_mart_primary" onClick={() => navigate("/registration-shop-information")} >Next</button> */}
            <button className="btn btn_mart_primary" type="submit">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SellerDocumentVerificationPersonal;
